export type AppEnvironment = "development" | "trial" | "production";

export const APP_ENVIRONMENTS = {
  development: "development",
  trial: "trial",
  production: "production",
} as const satisfies Record<AppEnvironment, AppEnvironment>;

export const DASHBOARD_ENVIRONMENTS: readonly AppEnvironment[] = [APP_ENVIRONMENTS.development, APP_ENVIRONMENTS.production];

export function resolveAppEnvironment(input: {
  NODE_ENV?: string;
  APP_ENV?: string;
  [key: string]: string | undefined;
}): AppEnvironment {
  if (input.APP_ENV === "trial") return "trial";
  return input.NODE_ENV === "production" ? "production" : "development";
}
